class CustomSelect {
	constructor(container) {
		this.container = container;
		this.input = container.querySelector('.custom-select__input');
		this.listbox = container.querySelector('.custom-select__listbox');
		this.options = Array.from(container.querySelectorAll('.custom-select__option'));
		this.isOpen = false;
		this.activeIndex = this.options.findIndex(opt => opt.getAttribute('aria-selected') === 'true') || 0;

		// Configuraciones opcionales
		const selectId = container.getAttribute('data-select-id');
		this.realSelect = selectId ? document.getElementById(selectId) : null;

		this.shouldSubmitForm = container.getAttribute('data-submit-form') === 'true';
		this.form = this.shouldSubmitForm ? container.closest('form') : null;

		this.init();
	}

	init() {
		// Events
		this.input.addEventListener('click', () => this.toggleListbox());
		this.input.addEventListener('keydown', e => this.handleInputKeydown(e));
		this.options.forEach((option, index) => {
			option.addEventListener('click', () => this.selectOption(index));
			option.addEventListener('keydown', e => this.handleOptionKeydown(e, index));
		});
		// Options aren't focusable; without this, mousedown blurs the combobox and focusout closes the list before click fires.
		this.listbox.addEventListener('mousedown', e => e.preventDefault());
		this.container.addEventListener('focusout', e => {
			if (this.isOpen && !this.container.contains(e.relatedTarget)) {
				this.closeListbox();
			}
		});
		document.addEventListener('click', e => {
			if (!this.container.contains(e.target)) {
				this.closeListbox();
			}
		});
	}

	toggleListbox() {
		this.isOpen ? this.closeListbox() : this.openListbox();
	}

	openListbox() {
		this.isOpen = true;
		this.input.setAttribute('aria-expanded', 'true');
		this.listbox.parentElement.setAttribute('aria-hidden', 'false');
		this.options.forEach(opt => opt.classList.remove('is-active'));
		this.options[this.activeIndex].classList.add('is-active');
	}

	closeListbox() {
		this.isOpen = false;
		this.input.setAttribute('aria-expanded', 'false');
		this.listbox.parentElement.setAttribute('aria-hidden', 'true');
	}

	selectOption(index) {
		this.options.forEach((opt, i) => {
			opt.setAttribute('aria-selected', String(i === index));
		});

		const selected = this.options[index];
		if (!this.container.hasAttribute('data-no-trigger-update')) {
			this.input.querySelector('span').textContent = selected.textContent.trim();
		}
		this.input.setAttribute('aria-activedescendant', selected.id);
		this.activeIndex = index;

		// ✅ Actualizar el <select> real
		if (this.realSelect) {
			this.realSelect.value = selected.getAttribute('data-value');

			// 🔔 Disparar el evento 'change'
			const event = new Event('change', { bubbles: true });
			this.realSelect.dispatchEvent(event);
		}

		// ✅ Enviar el formulario si corresponde
		if (this.shouldSubmitForm && this.form) {
			this.form.submit();
		}

		selected.click();
		this.closeListbox();
		this.input.focus();
	}

	handleInputKeydown(e) {
		switch (e.key) {
			case 'ArrowDown':
				e.preventDefault();
				this.openListbox();
				this.moveFocus(1);
				break;
			case 'ArrowUp':
				e.preventDefault();
				this.openListbox();
				this.moveFocus(-1);
				break;
			case 'Enter':
			case ' ':
				e.preventDefault();
				if (this.isOpen) {
					if (this.activeIndex !== null) {
						this.selectOption(this.activeIndex);
					}
				} else {
					this.openListbox();
				}
				break;
			case 'Escape':
				this.closeListbox();
				break;
		}
	}

	handleOptionKeydown(e, index) {
		switch (e.key) {
			case 'ArrowDown':
				e.preventDefault();
				this.moveFocus(1);
				break;
			case 'ArrowUp':
				e.preventDefault();
				this.moveFocus(-1);
				break;
			case 'Enter':
			case ' ':
				e.preventDefault();
				this.selectOption(index);
				break;
			case 'Escape':
				this.closeListbox();
				this.input.focus();
				break;
		}
	}

	moveFocus(step) {
		this.activeIndex = (this.activeIndex + step + this.options.length) % this.options.length;
		const newOption = this.options[this.activeIndex];
		this.input.setAttribute('aria-activedescendant', newOption.id);
		this.options.forEach(opt => opt.classList.remove('is-active'));
		newOption.classList.add('is-active');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.custom-select').forEach(container => {
		new CustomSelect(container);
	});
});
